module.exports = __webpack_public_path__ + "media/images/markitup/paragraph-c7d12d70805f1be2eaa69d750bacf1bd.png";